import { checkType } from '@testsigma/atoms';

export const validateFiles = (files): boolean =>
  files.map((file) => checkType(file)).filter((val) => !val).length == 0;
